var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsxFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.7678 11.9981L22.6516 0.881938C22.5778 0.808226 22.4902 0.749775 22.3938 0.709925C22.2974 0.670075 22.1941 0.649607 22.0898 0.649689H3.03353C2.40177 0.649689 1.79589 0.900653 1.34917 1.34737C0.902453 1.79409 0.651489 2.39997 0.651489 3.03173V37.9683C0.651489 38.6 0.902453 39.2059 1.34917 39.6526C1.79589 40.0993 2.40177 40.3503 3.03353 40.3503H31.618C32.2497 40.3503 32.8556 40.0993 33.3023 39.6526C33.749 39.2059 34 38.6 34 37.9683V12.5599C34.0001 12.4556 33.9796 12.3523 33.9398 12.2559C33.8999 12.1595 33.8415 12.0719 33.7678 11.9981ZM22.8838 3.35926L31.2885 11.7659H22.8838V3.35926ZM31.618 38.7623H3.03353C2.82294 38.7623 2.62098 38.6786 2.47208 38.5297C2.32317 38.3808 2.23951 38.1789 2.23951 37.9683V3.03173C2.23951 2.82114 2.32317 2.61918 2.47208 2.47027C2.62098 2.32137 2.82294 2.23771 3.03353 2.23771H21.2958V12.5599C21.2958 12.7705 21.3795 12.9724 21.5284 13.1213C21.6773 13.2702 21.8792 13.3539 22.0898 13.3539H32.412V37.9683C32.412 38.1789 32.3283 38.3808 32.1794 38.5297C32.0305 38.6786 31.8286 38.7623 31.618 38.7623Z",
    fill: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxFile);
export default __webpack_public_path__ + "static/media/xlsx_file.c557aa1740ecc358a1ceae158d53d350.svg";
export { ForwardRef as ReactComponent };